/* tslint:disable */
/* eslint-disable */
/**
 * Public Reply Service
 * Service submit public and query contact information of public replies
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Moisture of an avalanche
 * @export
 * @enum {string}
 */

export const AvalancheMoisture = {
    Dry: 'DRY',
    Wet: 'WET',
    Unknown: 'UNKNOWN'
} as const;

export type AvalancheMoisture = typeof AvalancheMoisture[keyof typeof AvalancheMoisture];



